export enum SubscriptionModel {
    PER_LOCATION = 'per_location',
    PER_USER = 'per_user'
}
